module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"join":"Join the event","participantName":"Enter your name or another guest\u0027s name","helpText":"Add participants to your event or, if you are a guest, enter your name to begin adding items!"},"fr_FR":{"join":"Ajouter un participant","participantName":"Entrez votre nom ou celui d\u0027un autre invité","helpText":"Ajoutez des participants à votre évènement ou, si vous êtes un invité, entrez votre nom pour commencer à ajouter des items !"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/UserForm.vue
// module id = 186
// module chunks = 1